import { differenceInDays } from 'date-fns';
import { useState } from 'react';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconClock } from '@sorare/core/src/atoms/icons/system/iconClock';
import { iconInfoCircle } from '@sorare/core/src/atoms/icons/system/iconInfoCircle';
import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandXS } from '@sorare/core/src/atoms/typography';
import { TimeLeft } from '@sorare/core/src/contexts/ticker/TimeLeft';
import type { Color } from '@sorare/core/src/style/types';
import { SetWillEndDialog } from '@sorare/marketplace/src/components/commonCard/SetWillEndDialog/index.tsx';

type Props = { endDate: Date };
export const SeriesBoardTimer = ({ endDate }: Props) => {
  const [showDialog, setShowDialog] = useState(false);

  const lessThan7Days = endDate && differenceInDays(endDate, new Date()) <= 7;
  const lessThan1Day = endDate && differenceInDays(endDate, new Date()) <= 1;

  let color: Color = 'var(--c-nd-600)';
  if (lessThan7Days) {
    color = 'var(--c-yellow-400)';
  }
  if (lessThan1Day) {
    color = 'var(--c-red-400)';
  }

  return (
    <>
      <ConditionalWrapper
        Wrapper={ButtonBase}
        wrap={!!lessThan7Days}
        props={{
          onClick: () => {
            setShowDialog(true);
          },
        }}
      >
        <Horizontal gap={0.5}>
          <FontAwesomeIcon color={color} icon={iconClock} size="xs" />
          <BrandXS color={color}>
            <TimeLeft time={endDate} />
          </BrandXS>
          {!!lessThan7Days && (
            <FontAwesomeIcon
              color="var(--c-nd-600)"
              icon={iconInfoCircle}
              size="xs"
            />
          )}
        </Horizontal>
      </ConditionalWrapper>
      {!!showDialog && (
        <SetWillEndDialog
          open={showDialog}
          onClose={() => {
            setShowDialog(false);
          }}
          endDate={endDate}
        />
      )}
    </>
  );
};
